export enum StoreIdentifiersEnum {
  ADMIN = 'admin',
  AUTH = 'auth',
  CONFIG = 'config',
  FAVORITES = 'favorites',
  NOTIFICATIONS = 'notifications',
  FEEDBACK = 'feedback',
  SEARCH = 'search',
  TOASTS = 'toasts',
  KNOWLEDGE = 'knowledge',
  ASK = 'ask',
  COPILOT = 'copilot',
}
